import request from '../utils/request';

/**
 * 获取验证码
 * @param {*} phone  
 * @returns 
 */
export function getcode(phone){
    return request({
        url:'/api/weixin/getAuthCode',
        method:'get',
        params:{
            phone:phone 
        }
    })
}

/**
 * 微信登录
 * @param {*} params wxcode phone 
 * @returns 
 */
 export function loginByWx(params){
    return request({
        url:'/api/weixin/loginByWx',
        method:'get',
        params
    })
}


/**
 * 校验验证码
 * @param {*} params wxcode phone 
 * @returns 
 */
 export function validMobileShortCode(params){
    return request({
        url:'/api/weixin/validMobileShortCode',
        method:'get',
        params
    })
}

/**
 * 车主码和我的车库手机号登录
 * @param {*} params 
 * @returns 
 */
 export function loginByPhone(params){
    return request({
        url:'/api/weixin/loginByPhone',
        method:'get',
        params
    })
}

/**
 * 新增车主码
 * @param {*} data 
 * @returns 
 */
 export function addOwnerCode(data){
    return request({
        url:'/api/carOwnerInfo',
        method:'post',
        data
    })
}
/**
 * 修改车主码-信息维护
 * @param {*} data 
 * @returns 
 */
 export function putOwnerCode(data){
    console.log(data)
    return request({
        url:'/api/carOwnerInfo',
        method:'put',
        data
    })
}

/**
 * 获取车主码
 * @param {*} data 
 * @returns 
 */
 export function getUserCode(data){
    return request({
        url:'',
        method:'post',
        data
    })
}

/**
 * 提交资料
 * @param {*} data 
 * @returns 
 */
 export function setUserInfo(data){
    return request({
        url:'',
        method:'post',
        data
    })
}

/**
 * 微信登录 查询微信手机号的车主信息
 * @param {*} data 
 * @returns 
 */
export function weixinCode(data){
    return request({
        url:'',
        method:'post',
        data
    })
}

/**
 * @description: 身份证上传
 * @param {*} data 
 */
 export function uploadFileCard(data) {
    return request({
      url: '/api/aliOssContent',
      method: 'post',
      data,
      config: {
        header: {
          'Content-Type': 'multipart/form-data',
        }
      }
    })
  }